import dictionary from '@/dictionary.json';

export default class TranslationService {
  static translate(key, language) {
    return dictionary[language][key];
  }
}
